import { SaleChangeStatusEnum } from '@src/domains/sale-changes/types/saleChange';

export const SaleChangeCheckoutOutcome = {
  Payment: 'payment',
  OrderDetails: 'order-details',
} as const;

export type SaleChangeCheckoutOutcome =
  | (typeof SaleChangeCheckoutOutcome)[keyof typeof SaleChangeCheckoutOutcome]
  | null;

export function resolveSaleChangeCheckoutOutcome(status: SaleChangeStatusEnum): SaleChangeCheckoutOutcome {
  if (status === SaleChangeStatusEnum.Pending) return SaleChangeCheckoutOutcome.Payment;
  if (status === SaleChangeStatusEnum.Applied) return SaleChangeCheckoutOutcome.OrderDetails;

  return null;
}
